import { Vue, Component } from 'vue-property-decorator';

@Component
export class AxVuetify extends Vue {
  private _baseClasses!: () => Record<string, string>;
  isFocused!: boolean;

  created() {
    this._baseClasses = ((this as unknown) as {
      _computedWatchers: {
        classes: {
          getter: () => Record<string, string>;
        };
      };
    })._computedWatchers.classes.getter;
  }

  get baseClasses() {
    return this._baseClasses();
  }

  get themeClasses() {
    return { 'theme--ax': true };
  }

  get computedColor() {
    if (this.isFocused) {
      return 'white';
    }
  }
}
